module.exports = __webpack_public_path__ + "img/S@2x.1f4d4b80.jpg";